module.exports = __webpack_public_path__ + "img/image-clinic@2x.c211422f.png";